/**
 * MeetingRequestService
 * Service for MeetingRequest entity operations
 * Route: api/meetingrequests
 * Controller: MeetingRequestsController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * MeetingRequestService
 * Handles meeting request CRUD operations
 * Maps to /api/meetingrequests endpoint
 */
export class MeetingRequestService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? MeetingRequestService.DEFAULT_SERVICE_PATH,
            basePath: MeetingRequestService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
MeetingRequestService.DEFAULT_SERVICE_PATH = 'meetings';
MeetingRequestService.BASE_PATH = 'api/meetingrequests';
//# sourceMappingURL=MeetingRequestService.js.map